import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BankAccountUpdateComponent } from '../athora/components/bank-account-update/bank-account-update.component';
import { CancelOperationComponent } from '../athora/components/cancel-operation/cancel-operation.component';
import { DocumentDownloadComponent } from '../athora/components/document-download/document-download.component';
import { DocumentUploadComponent } from '../athora/components/document-upload/document-upload.component';
import { AlertBannerComponent } from './components/alert-banner/alert-banner.component';
import { AssetsTableComponent } from './components/assets-table/assets-table.component';
import { BasicCardComponent } from './components/basic-card/basic-card.component';
import { BasicFormComponent } from './components/basic-form/basic-form.component';
import { BasicModalComponent } from './components/basic-modal/basic-modal.component';
import { BasicTableComponent } from './components/basic-table/basic-table.component';
import { BePaginatedTableComponent } from './components/be-paginated-table/be-paginated-table.component';
import { FrequencyPremiumChange } from './components/frequency-premium-change/frequency-premium-change.component';
import { LiquidationMaturityComponent } from './components/liquidation-maturity/liquidation-maturity.component';
import { NdgVariationComponent } from './components/ndg-variation/ndg-variation.component';
import { PolicyCardComponent } from './components/policy-card/policy-card.component';
import { PremiumPaymentReactivationComponent } from './components/premium-payment-reactivation/premium-payment-reactivation.component';
import { PremiumPaymentSuspensionComponent } from './components/premium-payment-suspension/premium-payment-suspension.component';
import { SpecificDateComponent } from './components/specific-date/specific-date.component';
import { TotalRedeemComponent } from './components/total-redeem/total-redeem.component';
import { UiModule } from './ui.module';

@NgModule({
  declarations: [
    BasicCardComponent,
    BasicFormComponent,
    SpecificDateComponent,
    BasicTableComponent,
    BePaginatedTableComponent,
    PolicyCardComponent,
    BasicModalComponent,
    TotalRedeemComponent,
    NdgVariationComponent,
    LiquidationMaturityComponent,
    DocumentDownloadComponent,
    DocumentUploadComponent,
    AssetsTableComponent,
    CancelOperationComponent,
    PremiumPaymentSuspensionComponent,
    PremiumPaymentReactivationComponent,
    FrequencyPremiumChange,
    BankAccountUpdateComponent,
    AlertBannerComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    UiModule,
  ],
  exports: [
    BankAccountUpdateComponent,
    BasicCardComponent,
    BasicFormComponent,
    SpecificDateComponent,
    BasicTableComponent,
    BePaginatedTableComponent,
    PolicyCardComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    UiModule,
    BasicModalComponent,
    TotalRedeemComponent,
    NdgVariationComponent,
    LiquidationMaturityComponent,
    DocumentDownloadComponent,
    DocumentUploadComponent,
    AssetsTableComponent,
    CancelOperationComponent,
    PremiumPaymentSuspensionComponent,
    PremiumPaymentReactivationComponent,
    FrequencyPremiumChange,
    AlertBannerComponent
  ]
})
export class SharedModule {}
